import React, { ForwardedRef, MouseEventHandler } from "react";
import { TypographyNew, TextVariant } from "../typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { useTheme } from "styled-components";
import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";

export const IconB = styled.button<{
  backgroundColor?: string;
  backgroundColorHover?: string;
  marginRight?: string;
  border?: boolean;
}>`
  position: relative;
  width: 40px;
  height: 40px;
  color: ${(props) => props.theme.colors.grays2};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.theme.borderRadius.small};
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "0px")};
  border: ${(props) =>
    props.border ? `1px solid ${props.theme.colors.grays5}` : "none"};
  flex-shrink: 0;
  &:hover {
    background-color: ${(props) => props.backgroundColorHover};
    cursor: pointer;
  }
`;

interface IconButtonNewProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  icon: IconDefinition;
  focused?: boolean;
  primary?: boolean;
  marginRight?: string;
  disabled?: boolean;
  hint?: string;
  border?: boolean;
  text?: string;
  size?: SizeProp;
  backgroundColor?: string;
  backgroundColorHover?: string;
  iconColor?: string;
  className?: string;
}

const IconButtonNew = (
  {
    primary,
    iconColor,
    icon,
    backgroundColor,
    backgroundColorHover,
    border,
    onClick,
    focused,
    hint = "",
    size,
    disabled,
    marginRight,
    className,
  }: IconButtonNewProps,
  ref: ForwardedRef<HTMLButtonElement>
): JSX.Element => {
  const theme = useTheme();
  let backgroundButtonColor, backgroundButtonColorHover: string;
  if (primary) {
    backgroundButtonColor = focused
      ? theme.colors.primary2
      : theme.colors.primary1;
    backgroundButtonColorHover = focused
      ? theme.colors.primary2
      : theme.colors.primary3;
  } else {
    backgroundButtonColor = focused
      ? theme.colors.grays4
      : backgroundColor ?? theme.colors.white;
    backgroundButtonColorHover = focused
      ? theme.colors.grays4
      : backgroundColorHover ?? theme.colors.grays7;
  }

  return (
    <IconB
      ref={ref}
      backgroundColorHover={backgroundButtonColorHover}
      backgroundColor={backgroundButtonColor}
      onClick={onClick}
      marginRight={marginRight}
      title={hint}
      disabled={disabled}
      border={border}
      className={className}
      type="button"
    >
      <TypographyNew variant={TextVariant.subtitle2}>
        <FontAwesomeIcon
          icon={icon as IconProp}
          size={size}
          color={
            disabled
              ? theme.colors.grays4
              : primary
              ? theme.colors.white
              : iconColor ?? theme.colors.grays2
          }
        />
      </TypographyNew>
    </IconB>
  );
};

export default React.forwardRef(IconButtonNew);
